import React, { Component } from 'react';
import { Alert, Breadcrumb, Button, Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';

import AntIcon from '../shared/components/AntIcon';
import { getApiErrorMessage, listAdminNews } from './api';

const imageStyle = {
  objectFit: 'cover',
  height: 100,
  width: 160,
  maxWidth: '100%',
};

class List extends Component {
  state = {
    articles: [],
    error: '',
    loading: true,
    pagination: {
      page: 1,
      limit: 20,
      totalCount: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };

  componentDidMount() {
    this.loadArticles();
  }

  loadArticles = ({ page = 1, limit = this.state.pagination.limit } = {}) => {
    this.setState({ loading: true, error: '' });
    return listAdminNews({ page, limit })
      .then((response) => {
        this.setState({
          articles: Array.isArray(response.data) ? response.data : [],
          pagination: response.pagination || {
            page,
            limit,
            totalCount: 0,
            totalPages: 0,
            hasNextPage: false,
            hasPrevPage: false,
          },
        });
      })
      .catch((error) => {
        this.setState({
          error: getApiErrorMessage(error, 'Failed to load news articles.'),
          articles: [],
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { articles, error, loading, pagination } = this.state;

    const columns = [
      {
        title: 'Date',
        dataIndex: 'date',
        width: 130,
        render: (date) => (date ? moment(date).format('ll') : '-'),
      },
      {
        title: 'Image',
        dataIndex: 'image',
        width: 160,
        render: (link, record) => (
          link ? (
            <img alt={record.title || ''} style={imageStyle} src={link} />
          ) : (
            <span style={{ color: 'rgba(0,0,0,0.45)' }}>No image</span>
          )
        ),
      },
      {
        title: 'Title',
        dataIndex: 'title',
        width: 400,
        render: (text, record) => (
          <Link to={`/news/${record._id}/edit`}>{text || '(untitled)'}</Link>
        ),
      },
      {
        title: 'Source',
        width: 180,
        dataIndex: 'source',
        render: (value) => value || '-',
      },
      {
        title: 'Featured',
        dataIndex: 'featured',
        width: 100,
        render: (value) => (value ? <Tag color="gold">Yes</Tag> : <Tag>No</Tag>),
      },
    ];

    return (
      <div id="news-list">
        <Breadcrumb>
          <Breadcrumb.Item>News</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <h4>
            Manage News
            <Button.Group size="small" className="is-right">
              <Button onClick={() => this.loadArticles({ page: pagination.page })}>
                <AntIcon type="reload" /> Refresh
              </Button>
              <Button>
                <Link to="/news/sources"><AntIcon type="global" /> Fetch News</Link>
              </Button>
              <Button>
                <Link to="/news/new"><AntIcon type="plus" /> New Article</Link>
              </Button>
            </Button.Group>
          </h4>

          {error && (
            <Alert
              type="error"
              showIcon
              style={{ marginBottom: 16 }}
              message={error}
            />
          )}

          <Table
            scroll={{ x: 1100 }}
            loading={loading}
            rowClassName={(a) => (a.featured ? 'featured' : '')}
            columns={columns}
            rowKey="_id"
            dataSource={articles}
            pagination={{
              current: pagination.page,
              pageSize: pagination.limit,
              total: pagination.totalCount,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30', '50'],
              onChange: (page, pageSize) => this.loadArticles({ page, limit: pageSize }),
              onShowSizeChange: (page, pageSize) => this.loadArticles({ page: 1, limit: pageSize }),
              showTotal: (total) => `Total ${total} articles`,
            }}
          />
        </div>
      </div>
    );
  }
}

export default List;
